const cheerio = typeof window === 'undefined' ? global.cheerio : window.cheerio

export const getModifiedHtml = (tableContent, styles) => {
  if (!tableContent) {
    return ''
  }
  const $ = cheerio.load(tableContent, null, false)

  $('*').removeAttr('style')

  $('th').each((_, element) => {
    const td = $('<td>').html($(element).html())
    $(element).replaceWith(td)
  })

  $('img').each((_, element) => {
    const $img = $(element)
    $img.attr('loading', 'lazy')
    $img.attr('decoding', 'async')
  })

  $('thead td').each((_, element) => {
    const htmlContent = $(element).html()
    const preservedContent = htmlContent.replace(/<(?!\/?(strong|b|img)\b)[^>]*>/gi, '')
    $(element).html(preservedContent)
  })

  $('tbody td').each((_, element) => {
    const htmlContent = $(element).html()
    const preservedContent = htmlContent.replace(/<(?!\/?(strong|b|img)\b)[^>]*>/gi, '')
    $(element).html(preservedContent)
  })

  const $theadRow = $('thead tr')
  const $tbody = $('tbody')
  $theadRow.each((_, row) => {
    const $row = $(row)
    $tbody.prepend($row)
  })

  $('thead').remove()

  const $rows = $('tbody tr')
  $rows.each((rowIndex, row) => {
    const $firstColumnCell = $(row).find('td').eq(0)
    const $secondColumnCell = $(row).find('td').eq(1)

    if (rowIndex % 2 === 0) {
      $firstColumnCell.addClass(styles.lightPurpleBackground)
    } else {
      $firstColumnCell.addClass(styles.darkPurpleBackground)
    }

    if (rowIndex % 2 === 0) {
      $secondColumnCell.addClass(styles.whiteBackground)
    } else {
      $secondColumnCell.addClass(styles.offWhiteBackground)
    }
  })

  const $firstRow = $('tbody tr').first()
  const cellContents = $firstRow
    .find('td')
    .map((_, cell) => $(cell).text().trim())
    .get()

  const $dataRows = $('tbody tr').slice(1)
  $dataRows.each((_, row) => {
    const $tds = $(row).find('td')
    $tds.each((index, td) => {
      $(td).attr('data-heading', cellContents[index])
    })
  })

  $('a').each((_index, element) => {
    const $a = $(element)
    $a.attr('target', '_blank')
  })

  return $.html()
}

export const renderHTMLContent = htmlContent => {
  const $ = cheerio.load(htmlContent, null, false)
  $('strong, bold').each((_, element) => {
    const text = $(element).text()
    if (/₹[\d,]+/.test(text)) {
      $(element).css('font-weight', 'bold').css('color', 'black')
    } else {
      $(element).replaceWith($(element).text())
    }
  })
  return $.html()
}
